import { Component, OnInit } from '@angular/core';
import { ShapeComponent } from '../../components/shape/shape.component';
import { MousePosition, LPAString } from '../../model/shape';
import { ShapeType } from '../../model/shape-types';

@Component({
  selector: 'app-lpa-string',
  templateUrl: './lpa-string.component.html',
  styleUrls: ['./lpa-string.component.scss']
})
export class LpaStringComponent extends ShapeComponent implements OnInit {

  constructor() {
    super();
    //   console.log('LpaStringComponent constructor');
    this.shape = new LPAString();
    this.shapeType = ShapeType.LPAString;
  }

  ngOnInit() {
    //   console.log('LpaStringComponent ngOnInit');
  }

  updateShapeProperties(value: any) {
    if (this.shape instanceof LPAString) {
      this.shape.shapeProperties.name = value.name;
      this.shape.value = value.value;
      this.shape.originX = value.x;
      this.shape.originY = value.y;
    }
  }

  setStyles() {
    const styles = {
      fill: this.shape.shapeProperties.strokeColor
    };
    return styles;
  }

  startDrawing(beginPosition: MousePosition): void {
    if (this.shape instanceof LPAString) {
      this.shape.originX = beginPosition.x;
      this.shape.originY = beginPosition.y;
      this.shape['font-family'] = 'Arial';
      this.shape['font-size'] = 16;
    }
    //   console.log('LapStringComponent startDrawing at ', beginPosition, ', ', this.shape);
  }

}
